/**
 * The ONE place that decides whether an invitation has expired from its `expires_at`
 * (invitations are valid for 7 days). Use it when the API only reports `pending` plus a date.
 *
 * @param {string|null|undefined} expiresAt ISO date.
 * @param {Date} [now]
 */
export const isInvitationExpired = (expiresAt, now = new Date()) => {
  if (!expiresAt) return false;
  const time = new Date(expiresAt).getTime();
  return Number.isFinite(time) && time < now.getTime();
};
